import { getCdnUrl } from 'storfox-api-hooks'

export function generateCdnUrl (url) {
  if (!url || url.match('^((http:\\/\\/)?|(https:\\/\\/)?)[a-zA-Z.\\-0-9]+\\.[a-z]{2,3}.*')) {
    return url
  }
  return `${getCdnUrl()}/${url}`
}
